// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonPresentationProps } from "@insite/mobius/Button";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { miniCartStyles } from "@rpsc/App/Components/MiniCart/MiniCart";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, styledScrollbar, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

const sharedMiniCartButton: ButtonPresentationProps = {
    sizeVariant: "large",
    css: css`
        flex: 1;

        ${TypographyStyle} {
            font-size: 14px;
            line-height: 19px;
        }
    `,
};

miniCartStyles.centerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 12px;
    `,
};

miniCartStyles.notifyWrapper = {
    css: css`
        width: 100%;
        padding: 12px;
    `,
};

miniCartStyles.noCartLinesNotify = miniCartStyles.notify = {
    css: css`
        margin: 0;
    `,
};

miniCartStyles.cartLinesWrapper = {
    css: css`
        position: relative;
        padding: 12px 12px 0;
        display: flex;
        flex-direction: column;
        gap: 12px;
        width: 100%;
        ${styledScrollbar({ width: 4, margined: 2 })}
        max-height: calc(100vh - 104px - ${({ headerHeight }: any) => headerHeight || "0px"});
    `,
};

miniCartStyles.cartLinesContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-bottom: 16px;
        flex: 1;
    `,
};

miniCartStyles.wrapper = {
    css: css`
        display: flex;
        width: 100%;
        flex-direction: column;
        justify-content: space-between;
        max-height: calc(100vh - 1px - ${({ headerHeight }: any) => headerHeight || "0px"});
    `,
};

miniCartStyles.bottomWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        border-top: 1px solid ${color("common.border")};
        padding: 12px;
        row-gap: 12px;
    `,
};

miniCartStyles.bottomSectionWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        position: relative;
        column-gap: 12px;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
        }
    `,
};

miniCartStyles.totalItem = {
    css: css`
        display: flex;
        align-items: baseline;
        gap: 4px;
    `,
};

miniCartStyles.totalLabel = {
    size: 14,
    weight: fontConfig.weight.regular,
    lineHeight: "22px",
};

miniCartStyles.totalValue = {
    variant: "h4",
    css: css`
        margin-bottom: 0;
    `,
};

miniCartStyles.checkoutButton = {
    ...sharedMiniCartButton,
    css: css`
        flex: 1;
        word-wrap: nowrap;
        white-space: nowrap;
        border: 0;
    `,
};

miniCartStyles.viewCartButton = {
    variant: "tertiary",
    ...sharedMiniCartButton,
};
